<template>
  <div id="article">
    <!-- 标题 -->
    <div class="title">
      <p>{{title}}</p>
    </div>
    <!-- 作者 归属 时间 -->
    <div class="article-info">
      <p>
<!--        <span>{{'作者'}}</span>-->
<!--        <span>{{'归属'}}</span>-->
        <span>{{time}}</span>
      </p>
    </div>
    <!-- content -->
    <div class="content" v-html="content"></div>
  </div>
</template>

<script>
  import { getArticle, formatDate } from '@/apis/article'

  export default {
    name: "index",
    data() {
      return {
        title: '',
        content: '',
        time: '',
        id:'',
      }
    },
    mounted() {
      this.id = this.$route.query.id
      getArticle({id: this.id}).then((res) => {
        // console.log(res)
        this.title = res.data.article_title
        this.content = res.data.article_content
        this.time = formatDate(res.data.article_createtime)
      })

      // this.$axios.get(`https://apitest.up-petroleum.com/#/article?id=${id}`)
      //     .then((res) => {
      //       this.title = res.data.article_title
      //         this.content = res.data.article_content
      //         this.time = formatDate(res.data.article_createtime)
      //     })

    }
  }
</script>

<style scoped>
  #article{
    width: 90vw;
    /*min-height: 20vw;*/
    margin: 0 auto;
    /*background: red;*/
  }
  .title{
    margin-top: 2vw;
    font-size: 5.1vw;
    line-height: 7vw;
  }
  .article-info{
    margin-top: 2vw;
    font-size: 3.8vw;
    margin-bottom: 3vw;
  }
  .article-info span{
    margin-right: 2vw;
  }
  .content{
    width: 86vw;
    margin: 0 auto;
  }
  .content>>>img{
    max-width: 100%;
  }
</style>
